module.exports = __webpack_public_path__ + "static/media/pig.7645c363.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/primary-interface/pig.svg
// module id = 623
// module chunks = 6